"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const react_onclickout_1 = __importDefault(require("react-onclickout"));
const color_1 = __importDefault(require("color"));
const CustomColorsContext_1 = require("../CustomColorsContext");
// Palette item that allows picking a color
class FontColorPaletteItem extends react_1.default.Component {
    static defaultProps = { position: "under" };
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }
    handleMouseDown = (ev) => {
        // Don't lose focus from editor
        ev.preventDefault();
        return this.setState({ open: !this.state.open });
    };
    render() {
        const popupPosition = {
            position: "absolute",
            left: 0,
            zIndex: 1000,
            backgroundColor: "white",
            border: "solid 1px #AAA",
            borderRadius: 3
        };
        if (this.props.position === "under") {
            popupPosition["top"] = 26;
        }
        else {
            popupPosition["bottom"] = 26;
        }
        return (react_1.default.createElement(react_onclickout_1.default, { onClickOut: () => this.setState({ open: false }) },
            react_1.default.createElement("div", { className: "mwater-visualization-text-palette-item", onMouseDown: this.handleMouseDown, style: { position: "relative" } },
                this.state.open ? (react_1.default.createElement("div", { style: popupPosition },
                    react_1.default.createElement(ColorPaletteComponent, { onSetColor: (color) => {
                            this.props.onSetColor(color);
                            return this.setState({ open: false });
                        } }))) : undefined,
                react_1.default.createElement("i", { className: "fas fa-palette" }))));
    }
}
exports.default = FontColorPaletteItem;
class ColorPaletteComponent extends react_1.default.Component {
    static contextType = CustomColorsContext_1.CustomColorsContext;
    renderColor(color) {
        return (react_1.default.createElement("td", null,
            react_1.default.createElement("div", { style: { width: 16, height: 15, backgroundColor: color, margin: 1 }, onMouseDown: (ev) => {
                    ev.preventDefault();
                    this.props.onSetColor(color);
                } })));
    }
    render() {
        const baseColors = [
            "#FF0000", // red
            "#FFAA00", // orange
            "#FFFF00", // yellow
            "#00FF00", // green
            "#00FFFF", // cyan
            "#0000FF", // blue
            "#9900FF", // purple
            "#FF00FF" // magenta
        ];
        const customColors = this.context?.customColors || [];
        return (react_1.default.createElement("div", { style: { padding: 5 } },
            react_1.default.createElement("table", null,
                react_1.default.createElement("tbody", null,
                    lodash_1.default.chunk(customColors.filter(color => color != null), 8).map((colorGroup, index) => (react_1.default.createElement("tr", { key: index }, colorGroup.map((color) => this.renderColor(color))))),
                    react_1.default.createElement("tr", null, lodash_1.default.map(lodash_1.default.range(0, 8), (i) => {
                        return this.renderColor((0, color_1.default)({ r: (i * 255) / 7, g: (i * 255) / 7, b: (i * 255) / 7 }).hex());
                    })),
                    react_1.default.createElement("tr", { style: { height: 5 } }),
                    react_1.default.createElement("tr", null, lodash_1.default.map(baseColors, (c) => this.renderColor(c))),
                    react_1.default.createElement("tr", { style: { height: 5 } }),
                    react_1.default.createElement("tr", null, lodash_1.default.map(baseColors, (c) => this.renderColor((0, color_1.default)(c).lighten(0.7).hex()))),
                    react_1.default.createElement("tr", null, lodash_1.default.map(baseColors, (c) => this.renderColor((0, color_1.default)(c).lighten(0.5).hex()))),
                    react_1.default.createElement("tr", null, lodash_1.default.map(baseColors, (c) => this.renderColor((0, color_1.default)(c).lighten(0.3).hex()))),
                    react_1.default.createElement("tr", null, lodash_1.default.map(baseColors, (c) => this.renderColor((0, color_1.default)(c).darken(0.3).hex()))),
                    react_1.default.createElement("tr", null, lodash_1.default.map(baseColors, (c) => this.renderColor((0, color_1.default)(c).darken(0.5).hex()))),
                    react_1.default.createElement("tr", null, lodash_1.default.map(baseColors, (c) => this.renderColor((0, color_1.default)(c).darken(0.7).hex())))))));
    }
}
